/**
 *
 * CopyQuoteLinkButton
 *
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import { DhlLink } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import { injectIntl } from "react-intl";
import { IntlPropType, trackContentInteraction } from "root/libs/core-libs/src";

const COPY_ID_PREFIX = "ShareButton";

const CopyQuoteLinkButton = injectIntl(
  ({ intl, trackEvent, trackingValue, shareUrl, utfDataObject }) => {
    const [clickedButton, setClickedButton] = useState(false);

    const onClickCopyURL = (event) => {
      // prevent default link behavior, but enabling user to copy link with right-click
      event.preventDefault();
      navigator.clipboard.writeText(shareUrl);
      setClickedButton(true);
      trackEvent(trackingValue);
      trackContentInteraction(utfDataObject);
    };

    const copyCTA = clickedButton
      ? intl.formatMessage({
          id: `${COPY_ID_PREFIX}.copyCTALabelClicked`,
        })
      : intl.formatMessage({
          id: `${COPY_ID_PREFIX}.copyCTALabel`,
        });

    return (
      <div>
        <DhlLink
          isFullWidth
          variant={clickedButton ? Variants.primary : Variants.outline}
          dataTestid="copy-quote"
          clickEvent={(e) => onClickCopyURL(e)}
          href={shareUrl}
        >
          <span>{copyCTA}</span>
        </DhlLink>
      </div>
    );
  }
);

CopyQuoteLinkButton.propTypes = {
  intl: IntlPropType.isRequired,
  dataTestid: PropTypes.string,
  trackEvent: PropTypes.func,
  trackingValue: PropTypes.object,
  shareUrl: PropTypes.string.isRequired,
  utfDataObject: PropTypes.object,
};

CopyQuoteLinkButton.defaultProps = {
  dataTestid: undefined,
  trackEvent: () => {},
  trackingValue: {},
  utfDataObject: {},
};

export default CopyQuoteLinkButton;
